// VRBB Rug Calculator — FSD v2 (Draft Orders architecture)
// Section 2 only. Section 1 (in-stock) and Section 3 (sample) are native Dawn blocks.
// CUSTOM_CHECKOUT_ENABLED:
//   false -> button opens pre-filled custom-order form
//   true  -> button POSTs to /draft-order and redirects to invoice_url

(function () {
  'use strict';

  var CUSTOM_CHECKOUT_ENABLED = true;
  var DRAFT_ORDER_ENDPOINT = '/apps/vrbb/draft-order';

  // ---------- utils ----------
  function calculatePrice(rate, widthIn, lengthIn) {
    return Math.ceil(rate * (widthIn / 12) * (lengthIn / 12) / 5) * 5;
  }
  function tradePrice(basePrice, tier) {
    if (tier === 'vip') return basePrice * 0.75;
    if (tier === 'trade') return basePrice * 0.80;
    return basePrice;
  }
  function toInches(feet, inches) {
    return parseInt(feet, 10) * 12 + parseInt(inches, 10);
  }
  function formatPrice(amount) {
    var hasCents = Math.round(amount * 100) % 100 !== 0;
    return '$' + amount.toLocaleString('en-US', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 2
    });
  }
  function formatDimension(totalInches) {
    var feet = Math.floor(totalInches / 12);
    var inches = totalInches % 12;
    return inches > 0 ? feet + ' ft ' + inches + ' in' : feet + ' ft';
  }

  // ---------- data ----------
  var dataEl = document.getElementById('vrbb-calculator-data');
  if (!dataEl) return;

  var rate = parseFloat(dataEl.dataset.rate);
  var maxWidth = parseInt(dataEl.dataset.maxWidth, 10);
  var maxLength = parseInt(dataEl.dataset.maxLength, 10);
  var isTrade = dataEl.dataset.isTrade === 'true';
  var tradeTier = dataEl.dataset.tradeTier;

  var inStockSizes = [];
  var instockEl = document.getElementById('vrbb-instock-data');
  if (instockEl) {
    try { inStockSizes = JSON.parse(instockEl.textContent) || []; } catch (e) { inStockSizes = []; }
  }
  function isInStockSize(widthIn, lengthIn) {
    for (var i = 0; i < inStockSizes.length; i++) {
      var pw = Math.round(inStockSizes[i].w * 12);
      var pl = Math.round(inStockSizes[i].l * 12);
      if (pw === widthIn && pl === lengthIn) return true;
    }
    return false;
  }

  // ---------- elements ----------
  var widthFtSel = document.getElementById('vrbb-width-ft');
  var widthInSel = document.getElementById('vrbb-width-in');
  var lengthFtSel = document.getElementById('vrbb-length-ft');
  var lengthInSel = document.getElementById('vrbb-length-in');
  var priceWrap = document.getElementById('vrbb-s2-price');
  var standardEl = document.getElementById('vrbb-s2-standard-price');
  var tradeEl = document.getElementById('vrbb-s2-trade-price');
  var nudgeEl = document.getElementById('vrbb-s2-nudge');
  var orderBtn = document.getElementById('vrbb-s2-order');
  var orderForm = document.getElementById('vrbb-order-form');

  var ORDER_LINK_TEXT = 'Order custom size now';

  if (!widthFtSel) return;

  var current = null;

  // ---------- dropdowns ----------
  for (var w = 2; w <= maxWidth; w++) {
    var o = document.createElement('option');
    o.value = w; o.textContent = w + ' ft';
    widthFtSel.appendChild(o);
  }

  function rebuildLength() {
    var selW = parseInt(widthFtSel.value, 10) || 2;
    var minL = Math.max(selW, 4);
    var keep = parseInt(lengthFtSel.value, 10);
    lengthFtSel.innerHTML = '<option value="">ft</option>';
    for (var l = minL; l <= maxLength; l++) {
      var op = document.createElement('option');
      op.value = l; op.textContent = l + ' ft';
      if (l === keep) op.selected = true;
      lengthFtSel.appendChild(op);
    }
  }

  function closeOrderForm() {
    if (orderForm) orderForm.hidden = true;
    if (orderBtn) {
      orderBtn.textContent = ORDER_LINK_TEXT;
      orderBtn.disabled = false;
      orderBtn.classList.remove('vrbb-order-open');
    }
  }

  function hidePrice() {
    closeOrderForm();
    if (priceWrap) priceWrap.style.display = 'none';
    if (nudgeEl) { nudgeEl.style.display = 'none'; nudgeEl.textContent = ''; }
    if (orderBtn) orderBtn.style.display = 'none';
    current = null;
  }

  function update() {
    closeOrderForm();
    var wFt = widthFtSel.value, lFt = lengthFtSel.value;
    if (!wFt || !lFt) { hidePrice(); return; }

    var widthIn = toInches(parseInt(wFt, 10), parseInt(widthInSel.value, 10));
    var lengthIn = toInches(parseInt(lFt, 10), parseInt(lengthInSel.value, 10));

    if (isInStockSize(widthIn, lengthIn)) {
      if (standardEl) standardEl.textContent = '';
      if (tradeEl) tradeEl.textContent = '';
      if (nudgeEl) {
        nudgeEl.textContent = 'This size is in stock above - choose it for shipping in 5-7 business days.';
        nudgeEl.style.display = '';
      }
      if (priceWrap) priceWrap.style.display = '';
      if (orderBtn) orderBtn.style.display = 'none';
      current = null;
      return;
    }

    if (nudgeEl) { nudgeEl.style.display = 'none'; nudgeEl.textContent = ''; }

    var base = calculatePrice(rate, widthIn, lengthIn);
    var shown = base, tierLabel = 'standard';
    if (isTrade) {
      shown = tradePrice(base, tradeTier);
      tierLabel = (tradeTier === 'vip') ? '25% Trade VIP Discount' : '20% Trade Discount';
      if (standardEl) standardEl.textContent = formatPrice(base);
      if (tradeEl) tradeEl.textContent = formatPrice(shown);
    } else {
      if (standardEl) standardEl.textContent = formatPrice(base);
    }

    if (priceWrap) priceWrap.style.display = '';
    if (orderBtn) orderBtn.style.display = '';

    current = {
      widthIn: widthIn, lengthIn: lengthIn,
      base: base, shown: shown, tierLabel: tierLabel
    };
  }

  rebuildLength();
  widthFtSel.addEventListener('change', function () { rebuildLength(); update(); });
  widthInSel.addEventListener('change', update);
  lengthFtSel.addEventListener('change', update);
  lengthInSel.addEventListener('change', update);

  // ---------- shortcuts ----------
  var shortcuts = document.querySelectorAll('.vrbb-shortcut');
  shortcuts.forEach(function (btn) {
    btn.addEventListener('click', function () {
      widthFtSel.value = parseInt(btn.dataset.width, 10);
      widthInSel.value = 0;
      rebuildLength();
      lengthFtSel.value = parseInt(btn.dataset.length, 10);
      lengthInSel.value = 0;
      update();
    });
  });

  // ---------- order button ----------
  function openCustomOrderForm() {
    if (!current) return;
    var wDisp = formatDimension(current.widthIn);
    var lDisp = formatDimension(current.lengthIn);
    var priceStr = formatPrice(current.shown);

    setText('vrbb-order-width-display', wDisp);
    setText('vrbb-order-length-display', lDisp);
    setText('vrbb-order-price-display', priceStr);
    setVal('vrbb-order-width-hidden', wDisp);
    setVal('vrbb-order-length-hidden', lDisp);
    setVal('vrbb-order-price-hidden', priceStr);

    if (orderBtn) {
      orderBtn.textContent = 'Your Custom Rug';
      orderBtn.classList.add('vrbb-order-open');
    }

    if (orderForm) {
      orderForm.hidden = false;
      orderForm.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function submitDraftOrder() {
    if (!current) return;
    orderBtn.textContent = 'Processing...';
    orderBtn.disabled = true;
    if (window.vrbbShowOverlay) window.vrbbShowOverlay();

    fetch(DRAFT_ORDER_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        product_id: dataEl.dataset.productId || null,
        vendor: dataEl.dataset.vendor || null,
        dimensions: {
          width_ft: parseInt(widthFtSel.value, 10),
          width_in: parseInt(widthInSel.value, 10),
          length_ft: parseInt(lengthFtSel.value, 10),
          length_in: parseInt(lengthInSel.value, 10)
        }
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.invoice_url) {
          window.location.href = data.invoice_url;
        } else {
          if (window.vrbbHideOverlay) window.vrbbHideOverlay();
          orderBtn.textContent = ORDER_LINK_TEXT;
          orderBtn.disabled = false;
          console.error('VRBB draft-order: no invoice_url', data);
        }
      })
      .catch(function (err) {
        if (window.vrbbHideOverlay) window.vrbbHideOverlay();
        orderBtn.textContent = ORDER_LINK_TEXT;
        orderBtn.disabled = false;
        console.error('VRBB draft-order error:', err);
      });
  }

  if (orderBtn) {
    orderBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!current) return;
      if (CUSTOM_CHECKOUT_ENABLED) submitDraftOrder();
      else openCustomOrderForm();
    });
  }

  // ---------- back-button recovery ----------
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      update();
    }
  });

  // ---------- order form submit ----------
  var orderFormEl = document.getElementById('vrbb-order-form-el');
  if (orderFormEl) {
    orderFormEl.addEventListener('submit', function () {
      try {
        window.sessionStorage.setItem('vrbb_order_submitted', '1');
      } catch (e) {}
    });
  }

  // ---------- helpers ----------
  function setText(id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; }
  function setVal(id, v) { var el = document.getElementById(id); if (el) el.value = v; }

})();
// ---------- expandable coordination (only one open at a time) ----------
  var allTriggers = document.querySelectorAll('.vrbb-expandable-trigger');
  allTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var targetId = trigger.dataset.target;
      allTriggers.forEach(function (otherTrigger) {
        if (otherTrigger.dataset.target !== targetId) {
          var otherTarget = document.getElementById(otherTrigger.dataset.target);
          if (otherTarget && !otherTarget.hidden) {
            otherTarget.hidden = true;
            otherTrigger.setAttribute('aria-expanded', 'false');
            otherTrigger.classList.remove('vrbb-open');
          }
        }
      });
    });
  });